import { useGetCurrentUserQuery } from '@/features/auth/authApi';
import { useSignOut } from '@/features/auth/useSignOut';
import { Button } from '@/ui/button';
import { Spinner } from '@/ui/spinner';

export function DashboardPage() {
  const { data: currentUser, isLoading } = useGetCurrentUserQuery();
  const { signOut, isSigningOut } = useSignOut();

  return (
    <main className="mx-auto max-w-reading p-8">
      <title>Dashboard · Tixbase</title>
      <header className="flex items-center justify-between gap-4">
        <p className="text-muted-foreground">
          {isLoading && 'Loading your account…'}
          {currentUser && (
            <>
              Signed in as <span className="font-semibold text-foreground">{currentUser.name}</span>
            </>
          )}
        </p>
        <Button type="button" variant="contrast" size="pill-sm" onClick={signOut} disabled={isSigningOut}>
          {isSigningOut && <Spinner data-icon="inline-start" />}
          Sign out
        </Button>
      </header>
    </main>
  );
}
